<template>
    <div class="camsContainer">
        <div class="nonGraphContainer">
            <div class="pageHeader">
                <ContentHeader :name=this.headerName :subHeader="subHeader" />
                <!-- <button @click="(event) => handleButtonPress(event)">New Violation</button> -->
            </div>
            <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
        </div>


        <div class="currentView">
            <div>
                <div class="dataTableSelectorGroup">
                    <div class="dataTableSelector">
                        <SearchBar class="gate-search" v-bind:search="search" :searchIcon="true"
                            v-bind:searchCallback="(data) => { this.performSearch(data) }" placeholder="Enter Search" />
                    </div>
                </div>
                <DataTable v-bind:tableData="tableData" v-bind:configuration="selectedItem" v-bind:openModalCallback="() => {
                    handleModal(selectedItem);
                }
                    " :headers="headers" />
            </div>
        </div>
    </div>

</template>

<script>
import ContentHeader from "../../ContentHeader";
import * as Constants from "../../../js/constants";
import DataTable from "../pageComps/DataTable.vue";
import SearchBar from "../pageComps/Search.vue";
import CTSRepository from "../../../js/CTSRepository";
// import Insights from "../../layout/Insights.vue";

export default {
    components: {
        ContentHeader,
        DataTable,
        SearchBar,
        // Insights
    },
    props: ["organizationData"],
    watch: {
        organizationData: function () {
            //this.communityId = newVal.organization_id
            this.communityId = "nautica2"
            this.performSearch()
        }
    },
    data() {
        return {
            communityId: this.$props.organizationData.organization_id,
            selectedItem: Constants.INCIDENTS,
            headerName: Constants.VIOLATIONS,
            subHeader: "Below is a record of all violations that have been logged",
            filters: [],
            tableData: [],
            search: "",
            cardInfo: Constants.DEFAULT_CARD_INFO
        };
    },
    created() {
        this.performSearch("").then((apiData) => {
            console.log("Finished getting and setting API Data", apiData);
        });
    },
    methods: {
        performSearch(data) {
            if (this.communityId == undefined) {
                return
            }
            this.search = data
            new CTSRepository(this.$props.organizationData).fetchViolations()
                .then((data) => {
                    console.log("Search Data", data);
                    this.tableData = data.data
                })
                .catch((err) => {
                    console.log("Error fetching violations", err)
                });
        },
        handleButtonPress(event) {
            console.log(event)
            this.$modal.show(Constants.CREATE_VIOLATION_MODAL);
        },
    },
};
</script>

<style scoped>
.dataTableSelectorGroup {
    display: flex;
    widows: 100%;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
    margin-right: 0px;
}

.selectorContent {
    width: 100%;
    color: white;
    font-size: 28px;
    display: inline;
    margin-right: 16px;
}

.selectorContent::placeholder {
    width: 100%;
    color: white;
    font-size: 28px;
}

/* .pageHeader button {
    background-color: #1890FFCC;
    color: white;
} */

.filterIcon {
    margin-right: 16px;
    display: inline;

}

.iconGroup {
    display: inline;
}
</style>